import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_metainfo = _resolveComponent("metainfo")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AppModal = _resolveComponent("AppModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_metainfo, null, {
      title: _withCtx(({ content }) => [
        _createTextVNode(_toDisplayString(content), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_router_view),
    _createVNode(_component_AppModal, {
      visible: _ctx.getShowModal,
      "modal-title": _ctx.getModalTitle,
      "modal-content": _ctx.getModalContent
    }, null, 8, ["visible", "modal-title", "modal-content"])
  ], 64))
}